import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  dark?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ className = '', dark = false }) => {
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`}>
      <img 
        src={dark ? "/mindclave-logo-dark.svg" : "/mindclave-logo.svg"}
        alt="MindClave Logo" 
        className="w-10 h-10 brightness-110 contrast-125"
      />
      <span className="text-2xl font-bold font-gabarito">
        <span className={dark ? "text-white" : "text-Color-Neutral-Darkest dark:text-Color-Neutral-Lightest"}>Mind</span>
        <span className="text-[#C97B5A] font-extrabold">Clave</span>
      </span>
    </Link>
  );
};